
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetoshirdicabpackage() {



    const cardData =
    {
        keyword: 'Pune to Shirdi Cab Package',
        heading: 'Mauli Cabs: Pune to Shirdi Cab Package',
        headingDescription: 'Mauli Cabs offers convenient and affordable Pune to Shirdi cab packages, ensuring a smooth and comfortable journey to the spiritual town of Shirdi. Whether you are planning a one-day trip or a longer stay, our packages include a range of vehicles like sedans, SUVs, and premium cars to suit your preferences. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a hassle-free and memorable ride to Shirdi, providing you with the best value for your journey.',

        top: 'Top Places to Visit in Shirdi with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shirdi Sai Baba Temple",
        "description": "The Shirdi Sai Baba Temple is one of the most famous religious destinations in India, dedicated to Sai Baba of Shirdi. Devotees from all over the world visit this temple to seek blessings, especially during festivals like Guru Purnima and Dussehra."
    },
    {
        "title": "Dwarkamai Mosque",
        "description": "Dwarkamai Mosque is a sacred site in Shirdi where Sai Baba spent a significant part of his life. The mosque houses the sacred fire that Sai Baba lit, and it remains an important pilgrimage site for devotees."
    },
    {
        "title": "Chavadi",
        "description": "Chavadi is another important site in Shirdi where Sai Baba used to sleep alternately with Dwarkamai. The place holds deep spiritual significance, and visitors can see the wooden structure where Baba sat during his final days."
    },
    {
        "title": "Sai Heritage Village",
        "description": "Sai Heritage Village is an interactive cultural park that offers a glimpse of the life and teachings of Sai Baba. It includes replicas of significant places from Sai Baba's life, along with an art gallery, library, and museum."
    },
    {
        "title": "Shani Shingnapur",
        "description": "Located about 70 km from Shirdi, Shani Shingnapur is a village known for its temple dedicated to Lord Shani (Saturn). The village is famous for the belief that the village is protected by Lord Shani and that no one locks their houses."
    },
    {
        "title": "Sai Baba's Samadhi Mandir",
        "description": "The Samadhi Mandir is where Sai Baba's mortal remains were laid to rest. It is the most visited part of the Shirdi Sai Baba Temple complex and holds immense spiritual significance for devotees."
    },
    {
        "title": "Nimgaon",
        "description": "Nimgaon is a small village located near Shirdi, which is the birthplace of Sai Baba's first disciple. The place holds historical and religious importance and is visited by those who wish to learn more about Baba’s teachings."
    },
    {
        "title": "Lendi Baug",
        "description": "Lendi Baug is a tranquil garden where Sai Baba spent a significant amount of time meditating. The garden has a temple dedicated to Sai Baba and is a peaceful place for reflection and spiritual contemplation."
    },
    {
        "title": "Khandoba Temple",
        "description": "Khandoba Temple is located on the outskirts of Shirdi and is believed to be the place where Sai Baba first arrived in Shirdi. The temple is dedicated to Lord Khandoba, an incarnation of Lord Shiva."
    },
    {
        "title": "Gurusthan",
        "description": "Gurusthan is an important religious site in Shirdi where Sai Baba is believed to have first appeared as a young boy under a neem tree. It is a revered spot for devotees seeking blessings from the saint."
    }
],

"services": [
    {
      "name": "Pune to Shirdi Taxi Package",
      "description": "Book a convenient and affordable taxi package for your journey from Pune to Shirdi. The package includes round trip and comfort throughout your journey."
    },
    {
      "name": "Pune to Shirdi Car Package",
      "description": "Our Pune to Shirdi car package provides a comfortable ride with professional drivers, ensuring a smooth journey to the holy town of Shirdi."
    },
    {
      "name": "Pune to Shirdi Package by Car",
      "description": "Book a custom package for your Pune to Shirdi trip by car, including transportation, sightseeing, and a hassle-free experience."
    },
    {
      "name": "Pune to Shirdi One Day Package by Car",
      "description": "Experience a one-day trip to Shirdi from Pune with our taxi package. Visit the Sai Baba temple and other landmarks in Shirdi comfortably within a day."
    },
    {
      "name": "Pune to Shirdi Package",
      "description": "Book a comprehensive Pune to Shirdi package, including travel, sightseeing, and a visit to the famous Sai Baba temple."
    },
    {
      "name": "Pune to Shirdi 1 Day Package",
      "description": "Take advantage of our 1-day Shirdi trip from Pune with a well-planned package that includes transportation, sightseeing, and temple darshan."
    },
    {
      "name": "One Day Trip to Shirdi from Pune",
      "description": "Make the most of a day by taking a one-day trip from Pune to Shirdi. The package covers round trip transportation, darshan, and quick sightseeing."
    },
    {
      "name": "Pune Airport to Shirdi Package",
      "description": "For those arriving at Pune Airport, our Pune Airport to Shirdi package offers a seamless transfer to Shirdi with comfortable and reliable transportation."
    },
    {
      "name": "Pune Shirdi Shani Shingnapur Tour Package",
      "description": "Our Pune to Shirdi, Shani Shingnapur tour package offers a spiritual trip covering the famous Shirdi temple and the Shani Shingnapur temple in a single day or more."
    },
    {
      "name": "Pune Shirdi Shani Shingnapur Trimbakeshwar Package",
      "description": "Experience a spiritual journey with our Pune to Shirdi, Shani Shingnapur, and Trimbakeshwar tour package. Visit all three holy destinations in one comprehensive tour."
    },
    {
      "name": "Pune Shirdi Tour",
      "description": "Book your Pune to Shirdi tour with us. Our package includes reliable transport, sightseeing, and ample time for temple visits and prayers."
    },
    {
      "name": "Pune Shirdi Trip",
      "description": "Enjoy a peaceful trip to Shirdi from Pune with our well-organized tour. Explore the Sai Baba temple and nearby attractions with a comfortable ride."
    },
    {
      "name": "Pune to Shirdi 2 Day Package",
      "description": "For a more relaxed journey, book our 2-day Pune to Shirdi package, which includes transportation, a stay at a hotel, sightseeing, and temple darshan."
    },
    {
      "name": "Pune to Shirdi Mini Bus Package",
      "description": "For group travel, our Pune to Shirdi mini bus package offers comfortable transport for a large group with a dedicated driver, ensuring a safe and enjoyable journey."
    },
    {
      "name": "Pune to Shirdi Darshan Package",
      "description": "Book our special Pune to Shirdi Darshan package, where we ensure your temple visit is smooth, and we also provide a personalized itinerary for sightseeing."
    }
  ],
  "tableData": [
    ["Pune to Shirdi Taxi Package", "Pune to Shirdi Car Package"],
    ["Pune to Shirdi Package by Car", "Pune to Shirdi One Day Package by Car"],
    ["Pune to Shirdi Package", "Pune to Shirdi 1 Day Package"],
    ["One Day Trip to Shirdi from Pune", "Pune Airport to Shirdi Package"],
    ["Pune Shirdi Shani Shingnapur Tour Package", "Pune Shirdi Shani Shingnapur Trimbakeshwar Package"],
    ["Pune Shirdi Tour", "Pune Shirdi Trip"],
    ["Pune to Shirdi 2 Day Package", "Pune to Shirdi Mini Bus Package"],
    ["Pune to Shirdi Darshan Package", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and timely service for your Pune to Shirdi journey. Our professional drivers ensure timely pickups and drop-offs, allowing you to focus on your trip to the holy city of Shirdi without any worries about punctuality."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Shirdi trip, we provide a range of comfortable and spacious vehicles. From air-conditioned sedans to roomy SUVs, all our vehicles are well-maintained to ensure a comfortable and smooth ride, making your pilgrimage experience more pleasant."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are familiar with the Pune to Shirdi route. They ensure a safe and smooth journey by taking the best routes and avoiding traffic, so you can relax and enjoy the ride to Shirdi."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable and transparent pricing for your Pune to Shirdi cab package. We provide clear and upfront pricing with no hidden charges, ensuring that you get the best value for your money for a comfortable and hassle-free trip."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure that your journey from Pune to Shirdi is secure and comfortable."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Shirdi cab package. Whether you prefer an early morning departure or a late-night return, our customer service team is always available to assist you with booking your ride."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Shirdi cab package with Mauli Cabs is quick and easy. You can book online through our website or mobile app, or simply contact our customer service team for personalized assistance, ensuring a smooth and hassle-free experience."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Shirdi journey. Whether you're traveling solo, with family, or in a group, we can tailor the cab service to meet your specific needs and preferences, ensuring a comfortable and enjoyable trip to the holy city."
    }
]

















    }


    const faqData = [
        {
            question: 'How do I book a cab from Pune to Shirdi with Mauli Cabs?',
            answer: 'Booking a cab from Pune to Shirdi with Mauli Cabs is easy! You can book via our website or mobile app by entering your pickup location (Pune) and destination (Shirdi), choosing the vehicle type, and confirming the booking. You can also call our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Shirdi trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for the Pune to Shirdi route, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can select a vehicle that best suits your comfort and travel needs.',
        },
        {
            question: 'Is the fare for the Pune to Shirdi trip fixed?',
            answer: 'Yes, the fare for the Pune to Shirdi trip is fixed and transparent. The fare includes all charges such as tolls, taxes, and driver fees, with no hidden costs. The total fare will be displayed upfront when you confirm your booking.',
        },
        {
            question: 'Can I book a round trip for Pune to Shirdi?',
            answer: 'Yes, you can easily book a round trip from Pune to Shirdi. Just provide your return details when making the booking, and we’ll ensure a seamless journey back as well.',
        },
        {
            question: 'How long does the journey from Pune to Shirdi take?',
            answer: 'The journey from Pune to Shirdi typically takes about 5 to 6 hours, depending on traffic and road conditions. Our drivers are experienced and know the best routes to make your journey as smooth and timely as possible.',
        },
        {
            question: 'Are the drivers experienced for the Pune to Shirdi route?',
            answer: 'Yes, all Mauli Cabs drivers are highly trained, experienced, and familiar with the best routes for the Pune to Shirdi trip. They ensure your safety, comfort, and timely arrival.',
        },
        {
            question: 'Can I make stops during my journey from Pune to Shirdi?',
            answer: 'Yes, you can make stops along the way for refreshments, meals, or sightseeing. Our drivers will happily accommodate any requests to ensure a pleasant and comfortable trip.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained for the Pune to Shirdi trip?',
            answer: 'Yes, all our cabs for the Pune to Shirdi trip are fully air-conditioned and regularly maintained to ensure comfort, cleanliness, and safety throughout your journey.',
        },
        {
            question: 'Can I cancel or modify my booking for the Pune to Shirdi trip?',
            answer: 'Yes, you can cancel or modify your booking for the Pune to Shirdi trip easily. We offer a flexible cancellation policy via our website or app, and our customer support team is always ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Shirdi trip?',
            answer: 'Mauli Cabs offers competitive pricing, a variety of vehicles to suit your needs, professional drivers, and a commitment to providing a comfortable, safe, and timely journey. Whether you are visiting Shirdi for religious purposes or leisure, we ensure a hassle-free travel experience.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rajesh Kumar",
            position: "Devotee",
            text: "I traveled from Pune to Shirdi with Mauli Cabs for a spiritual journey, and the experience was fantastic. The car was clean and comfortable, and the driver was very courteous. I’ll certainly book again for future trips to Shirdi.",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Priya Verma",
            position: "Pilgrim",
            text: "Mauli Cabs made my trip from Pune to Shirdi so easy and enjoyable. The driver knew the best route, and the car was well-maintained. I felt relaxed and safe throughout the journey. Highly recommend them for any travel to Shirdi!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Shirdi Cab Package by Mauli Cabs",
        "description": "Mauli Cabs offers tailored Pune to Shirdi cab packages, including one-day and multi-day trips, with options for bus and car rentals. Enjoy a pilgrimage tour to Shirdi, including stops at popular sites like Shani Shingnapur and Trimbakeshwar, with comfortable and affordable travel options.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
     
   


    return (
        <div>
            <GTag/>
 <Helmet>
        <title>Pune to Shirdi Cab Package | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Shirdi cab package with Mauli Cabs. Choose from one-day, two-day, or customized tours by car or bus, including visits to Shirdi, Shani Shingnapur, Trimbakeshwar, and Ajanta Ellora. Enjoy a smooth and comfortable journey with our affordable tour packages."
        />
        <meta
          name="keywords"
          content="Pune to Shirdi Taxi Package, Pune to Shirdi Car Package, Pune to Shirdi Package by Car, Pune to Shirdi One Day Package by Car, Pune to Shirdi Package, Pune to Shirdi 1 Day Package, One Day Trip to Shirdi from Pune, Pune Airport to Shirdi Package, Pune Shirdi Shani Shingnapur Tour Package, Pune Shirdi Shani Shingnapur Trimbakeshwar Package, Pune Shirdi Tour, Pune Shirdi Trip, Pune to Shirdi 2 Day Package, Pune to Shirdi Mini Bus Package, Pune to Shirdi Darshan Package, Pune to Shirdi One Day Package by Bus, Pune to Shirdi One Day Package, Pune to Shirdi Tour Package by Bus, Pune to Shirdi Tour Package by Car, Shirdi Ajanta Ellora Tour Package from Pune, Shirdi Darshan Package from Pune, Shirdi Nasik Trimbakeshwar Tour Package from Pune, Pune to Ajanta Ellora Cab"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      



            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/39.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshirdicabpackage;